import angular from 'angular';
import smsTemplatesSharingPrivacy from './smsTemplatesSharingPrivacy';

export default angular
  .module('components.smsTemplatesSharingPrivacy', [])
  .component('smsTemplatesSharingPrivacy', smsTemplatesSharingPrivacy).name;
